<template>
  <v-container clipped fill-height fixed fluid class="matching-container">
    <v-global-progress-bar namespace="matching" :flags="progressBarFlags" />
    <v-matching-toolbar />
    <v-matching-content />
    <!-- labelers ranking of the current matches -->
    <v-match-ranking-sidebar />
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapMutations, mapActions, mapGetters } = createNamespacedHelpers("matching");

import VGlobalProgressBar from "@/components/progress/GlobalProgressBar.vue";
import VMatchingContent from "./content/Layout.vue";
import VMatchingToolbar from "./components/toolbar/Layout";
import VMatchRankingSidebar from "./components/MatchRankingSidebar";

export default {
  components: {
    VGlobalProgressBar,
    VMatchingContent,
    VMatchingToolbar,
    VMatchRankingSidebar,
  },
  data: () => ({
    progressBarFlags: [
      "loadingBrands",
      "loadingClassifications",
      "loadingSimilarItems",
      "loadingPivotItems",
      "loadingProductCreation",
      "loadingQmps",
      "loadingRemoveQmiFromQmp",
      "loadingRemoveQmp"
    ]
  }),
  methods: {
    ...mapMutations(["loadSettingsFromLocalStorage"]),
    ...mapActions(["setSellerHomologations"])
  },
  computed: {
    ...mapGetters(["groupedSellerHomologations"])
  },
  created() {
    this.loadSettingsFromLocalStorage();
    this.setSellerHomologations();
  }
};
</script>

<style scoped>
.matching-container {
  padding-top: 64px;
}
</style>